export async function bootstrap() {
	console.info("fake app bootstrap");
	return true;
}

export async function mount() {
	console.info("fake app mount");
	return true;
}

export async function unmount() {
	console.info("fake app unmount");
	return true;
}
